export default `
varying vec2 vUv;
uniform sampler2D uMainPosition;
uniform float uParticleSize; 

void main() {

    vUv = uv;
    vec4 color = texture2D(uMainPosition, vUv);
    vec3 newpos = position;
    newpos.xy = color.xy;
    
    vec4 mvPosition = modelViewMatrix * vec4( newpos, 1.0 );

    gl_PointSize =  ( uParticleSize / -mvPosition.z );

    gl_Position = projectionMatrix * mvPosition;
}
`;
//# sourceMappingURL=vertex.js.map